import React from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";
import ListingGrid from "../common/ListingGrid";

type Props = {
  myListings: Object,
  soldListings: Object,
  className: string,
};

const AgentListings = ({
  classes,
  className,
  myListings,
  soldListings,
}: Props) => {
  return (
    <div className={classNames(classes.root, className)}>
      {myListings &&
        myListings.length > 0 && (
          <div className={classes.container}>
            <div className={classes.title}>My Listings</div>
            <ListingGrid listings={myListings} />
          </div>
        )}
      {soldListings &&
        soldListings.length > 0 && (
          <div className={classes.container}>
            <div className={classes.title}>Sold Listings</div>
            <ListingGrid listings={soldListings} />
          </div>
        )}
    </div>
  );
};
export default withStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  title: {
    fontSize: "20px",
    color: theme.colors.gray["900"],
    fontWeight: "700",
    textAlign: "center",
    marginBottom: theme.spacing.unit * -1.5,
  },
}))(AgentListings);
